'use strict';

var _fund_provider = require('../components/fund_provider');

var _fund_provider2 = _interopRequireDefault(_fund_provider);

var _product_detail_app = require('../components/product_detail_app.js');

var _product_detail_app2 = _interopRequireDefault(_product_detail_app);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDom = require('react-dom');

var _reactDom2 = _interopRequireDefault(_reactDom);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_reactDom2.default.render(_react2.default.createElement(
  _fund_provider2.default,
  window.fundsMarketingConfiguration,
  _react2.default.createElement(_product_detail_app2.default, null)
), document.getElementById("react-app"));